import { useState, useRef } from 'react';
import classNames from 'classnames';

import { Popover, Tooltip } from 'components-antd';
import { Icons as TemplateIcons } from '../../../../Icons';
import { Close } from 'components/Icons';

import { useOutsideClick } from 'hooks';

import commonStyles from './../../styles.module.scss';
import styles from './styles.module.scss';

export const ChecklistsPopover = ({ checklists }) => {
  const ref: any = useRef();
  const popoverRef: any = useRef();
  const [open, setOpen] = useState(false);

  useOutsideClick([ref, popoverRef], () => setOpen(false));
  if (!checklists?.length) return null;

  const PopoverContent = () => (
    <div ref={popoverRef} className={commonStyles.popoverContent}>
      <div className={commonStyles.header}>
        <p className={commonStyles.title}>Checklists</p>
        <Close onClick={() => setOpen(false)} className={commonStyles.closeIcon} />
      </div>
      <div className={classNames(commonStyles.content, styles.checklistContent)}>
        {checklists?.map((item, idx) => (
          <div key={idx} className={styles.checlistItem}>
            <div className={styles.left}>
              <div className={styles.checklistCircle} />
              <span>{item?.Name}</span>
            </div>
            {item?.Required && <span className={styles.requiredText}>Required</span>}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div ref={ref}>
      <Popover
        open={open}
        placement="bottomRight"
        overlayClassName={commonStyles.popoverContainer}
        content={<PopoverContent />}
      >
        <Tooltip
          title="Checklists"
          placement="top"
          trigger="hover"
          overlayClassName={commonStyles.infoTooltip}
        >
          <button
            className={commonStyles.popoverBtn}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen(true);
            }}
          >
            <TemplateIcons variant={TemplateIcons.CHECKLIST} />
          </button>
        </Tooltip>
      </Popover>
    </div>
  );
};
